(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  function initNewsletterPopup() {
    var popup = document.querySelector('[data-newsletter-popup]');
    if (!popup) return;

    if (window.location.pathname !== '/') return;

    var overlay = popup.querySelector('[data-newsletter-popup-overlay]');
    var close = popup.querySelector('[data-newsletter-popup-close]');
    var CLOSED_KEY = 'newsletterPopupClosed';

    // if (localStorage.getItem(CLOSED_KEY) === 'true') {
    //   return;
    // }

    function openPopup() {
      popup.classList.remove('is-closing');
      popup.hidden = false;
    }

    function closePopup() {
      if (popup.hidden || popup.classList.contains('is-closing')) return;

      popup.classList.add('is-closing');
      popup.addEventListener('transitionend', function hidePopup(event) {
        if (event.target !== popup || event.propertyName !== 'opacity') return;
        popup.hidden = true;
        popup.classList.remove('is-closing');
        popup.removeEventListener('transitionend', hidePopup);
      });
      localStorage.setItem(CLOSED_KEY, 'true');
    }

    setTimeout(openPopup, 5000);

    if (overlay) overlay.addEventListener('click', closePopup);
    if (close) close.addEventListener('click', closePopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterPopup);
  } else {
    initNewsletterPopup();
  }

  } catch(e) { console.error(e); }
})();
})();
